import { Helmet } from 'react-helmet-async';

export default function SEOHead({ title, description, canonical, type = 'website', jsonLd, hreflang, indexable = true, ogTitle, ogDescription }) {
  const siteName = 'ODDSIS';
  const fullTitle = title
    ? (title.includes('ODDSIS') ? title : `${title} | ${siteName}`)
    : siteName;
  const desc = description || '30+ bahisçide profesyonel oran karşılaştırması. Değer bahisleri ve kesin bahis fırsatları.';
  const ogT = ogTitle || fullTitle;
  const ogD = ogDescription || desc;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {!indexable && <meta name="robots" content="noindex, nofollow" />}
      {canonical && <link rel="canonical" href={canonical} />}
      <meta property="og:title" content={ogT} />
      <meta property="og:description" content={ogD} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="ODDSIS" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={ogT} />
      <meta name="twitter:description" content={ogD} />
      {hreflang && hreflang.map((h, i) => (
        <link key={i} rel="alternate" hrefLang={h.lang} href={h.href} />
      ))}
      {jsonLd && jsonLd.map((schema, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(schema)}</script>
      ))}
    </Helmet>
  );
}
